var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParetoChart',{ref:"chart",attrs:{"unit":_vm.unit,"scale":_vm.scale,"title":_vm.title,"loading":_vm.loading,"criticalpart":_vm.criticalpart,"columncolor":_vm.columncolor},on:{"selectpart":_vm.fetchData}})
}
var staticRenderFns = []

export { render, staticRenderFns }